import { render, staticRenderFns } from "./404.vue?vue&type=template&id=44b2bc6f&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=44b2bc6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b2bc6f",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/404.vue
// module id = 254
// module chunks = 1